import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const location = useLocation();

  useEffect(() => {
    // Don't scroll to top when the user navigates back/forward (POP action).
    // This lets pages like Matches restore their saved scroll position.
    if (location.key === "default") return; // very first load
    if ((window.history.state?.idx ?? -1) < (window._lastHistoryIdx ?? 0)) {
      // Going back — skip scroll reset
      window._lastHistoryIdx = window.history.state?.idx ?? 0;
      return;
    }
    window._lastHistoryIdx = window.history.state?.idx ?? 0;
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [location.pathname, location.key]);

  return null;
}
